import qs from 'qs';
import { useMemo, useCallback, useState } from 'react';
import { useEffectAfterInit } from './effect-after-init';

export function useQueryString(replaceHistory=false, location=document.location) {
  let intitialQuery = useMemo(() => qs.parse(location.search.substring(1)), []);
  let [query, setQuery] = useState(intitialQuery);

  let updateQuery = useCallback(delta => setQuery(current => ({ ...current, ...delta })), []);

  useEffectAfterInit(() => {
    let newUrl = new URL(location.href);

    newUrl.search = `?${qs.stringify(query)}`;

    if (replaceHistory) {
      history.replaceState(null, '', newUrl.href);
    } else {
      history.pushState(null, '', newUrl.href);
    }
  }, [query, replaceHistory]);

  return {
    query,
    updateQuery,
  };
}
